class ValuesSpin extends PIXI.Container {
  constructor() {
    super();
    this.valueOverlays = [];
    this.coinValuesActive = [];
    this.moonValueActive = [];
    this;
    messageBus.subscribe(
      "spinner:GameConfigEvent",
      this.onGameConfigEvent.bind(this)
    );
  }

  initialise() {
    const self = this;
    let index = 0;
    for (let reel = 0; reel < gameData.numReels; reel++) {
      for (let row = 0; row < gameData.numRows; row++) {
        const slotCell = reel * gameData.numRows + row;

        //Basegame
        let parentBG = resourceManager.get(
          `slotContainer:reelContainer:reel${reel}:symbol${row}:symbol_standard:childContainer`
        );

        let valueContainer = resourceManager.createObject(
          "container",
          `spinValueCnt${slotCell}`,
          parentBG,
          {
            x: 0,
            y: 0,
          }
        );

        //Cashvalues
        let coinSpinCashOverlay;
        let miniSpinOverlay;
        let minorSpinOverlay;
        let majorSpinOverlay;
        let megaSpinOverlay;

        if (reel === 0 || reel === 5) {
          coinSpinCashOverlay = resourceManager.createObject(
            "text",
            `coinSpinCashOverlay${slotCell}`,
            valueContainer,
            {
              text: "0.00",
              fontDefinition: "potAwards",
              x: -3,
              y: 27.5,
              fontSize: 25,
              width: 120,
              maxWidth: 120,
              anchor: 0.5,
            }
          );
        } else {
          coinSpinCashOverlay = resourceManager.createObject(
            "text",
            `coinSpinCashOverlay${slotCell}`,
            valueContainer,
            {
              text: "",
              fontDefinition: "cashLinkCoinText",
              maxWidth: 120,
              anchor: 0.5,
              x: 3,
            }
          );
          miniSpinOverlay = resourceManager.createObject(
            "sprite",
            `miniOverlay${slotCell}`,
            valueContainer,
            {
              anchor: 0.5,
              fileName: "potBonus/Mini_jackpot.png",
            }
          );
          minorSpinOverlay = resourceManager.createObject(
            "sprite",
            `minorOverlay${slotCell}`,
            valueContainer,
            {
              anchor: 0.5,
              fileName: "potBonus/Minor_jackpot.png",
            }
          );
          majorSpinOverlay = resourceManager.createObject(
            "sprite",
            `majorOverlay${slotCell}`,
            valueContainer,
            {
              anchor: 0.5,
              fileName: "potBonus/Major_jackpot.png",
            }
          );
          megaSpinOverlay = resourceManager.createObject(
            "sprite",
            `megaOverlay${slotCell}`,
            valueContainer,
            {
              anchor: 0.5,
              fileName: "potBonus/Mega_jackpot.png",
            }
          );
          miniSpinOverlay.visible = false;
          minorSpinOverlay.visible = false;
          majorSpinOverlay.visible = false;
          megaSpinOverlay.visible = false;
        }

        //Moons
        let spinMoonCnt = resourceManager.createObject(
          "container",
          `spinMoonCnt${slotCell}`,
          parentBG,
          {
            maxWidth: 120,
            anchor: 0.5,
          }
        );

        let spinMoonValue1 = resourceManager.createObject(
          "sprite",
          `moonValueOverlay1`,
          spinMoonCnt,
          {
            fileName: "slots/symbols/Moon/Freespins1.png",
            anchor: 0.5,
          }
        );
        let spinMoonValue2 = resourceManager.createObject(
          "sprite",
          `moonValueOverlay2`,
          spinMoonCnt,
          {
            fileName: "slots/symbols/Moon/Freespins2.png",
            anchor: 0.5,
          }
        );
        let spinMoonValue3 = resourceManager.createObject(
          "sprite",
          `moonValueOverlay3`,
          spinMoonCnt,
          {
            fileName: "slots/symbols/Moon/Freespins3.png",
            anchor: 0.5,
          }
        );
        let spinMoonValue4 = resourceManager.createObject(
          "sprite",
          `moonValueOverlay4`,
          spinMoonCnt,
          {
            fileName: "slots/symbols/Moon/Freespins4.png",
            anchor: 0.5,
          }
        );

        //Cashlink
        let parentCL = resourceManager.get(
          `slotContainer:cashLinkFeatureContainer:cashLinkFeature:cashLinkReels:reel${slotCell}:symbol0:symbol:childContainer`
        );

        let cashCoinLinkSpin = resourceManager.createObject(
          "text",
          `cashCoinLinkSpin${slotCell}`,
          parentCL,
          {
            text: "",
            fontDefinition: "cashLinkCoinText",
            maxWidth: 120,
            anchor: 0.5,
          }
        );

        coinSpinCashOverlay.visible = false;
        cashCoinLinkSpin.visible = false;
        spinMoonValue1.visible = false;
        spinMoonValue2.visible = false;
        spinMoonValue3.visible = false;
        spinMoonValue4.visible = false;
        coinSpinCashOverlay.visible = false;

        this.valueOverlays.push({
          valuesParentCL: parentCL,
          valuesParent: parentBG,
          valueCnt: valueContainer,
          moonCnt: spinMoonCnt,
          cashCoinLinkSpin: cashCoinLinkSpin,
          coinSpin: coinSpinCashOverlay,
          miniSpin: miniSpinOverlay,
          majorSpin: majorSpinOverlay,
          megaSpin: megaSpinOverlay,
          minorSpin: minorSpinOverlay,
          spinMoonValue1: spinMoonValue1,
          spinMoonValue2: spinMoonValue2,
          spinMoonValue3: spinMoonValue3,
          spinMoonValue4: spinMoonValue4,
        });
        index++;
      }
    }

    Reflex.registerEventHandler("orientationChange", self.onOrientationChange);

    this.removeAllChildren();
  }

  onOrientationChange() {}

  setCoinSpinValue(slotCell, coinValue) {
    const value =
      PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
        coinValue / 100
      );
    this.valueOverlays[slotCell].coinSpin.setText(value);
  }

  removeAllChildren() {
    for (let i = 0; i < this.valueOverlays.length; i++) {
      this.valueOverlays[i].valuesParent.removeChild(
        this.valueOverlays[i].valueCnt
      );
      this.valueOverlays[i].valuesParent.removeChild(
        this.valueOverlays[i].moonCnt
      );
    }
  }

  addOrRemoveValueContainer(show, slotCell) {
    if (show) {
      this.valueOverlays[slotCell].valuesParent.addChild(
        this.valueOverlays[slotCell].valueCnt
      );
    } else {
      this.valueOverlays[slotCell].valuesParent.removeChild(
        this.valueOverlays[slotCell].valueCnt
      );
    }
  }

  addOrRemoveCLValueContainer(show, slotCell) {
    if (show) {
      this.valueOverlays[slotCell].valuesParentCL.addChild(
        this.valueOverlays[slotCell].cashCoinLinkSpin
      );
    } else {
      this.valueOverlays[slotCell].valuesParent.removeChild(
        this.valueOverlays[slotCell].cashCoinLinkSpin
      );
    }
  }

  addOrRemoveMoonContainer(show, slotCell) {
    if (show) {
      this.valueOverlays[slotCell].valuesParent.addChild(
        this.valueOverlays[slotCell].moonCnt
      );
    } else {
      this.valueOverlays[slotCell].valuesParent.removeChild(
        this.valueOverlays[slotCell].moonCnt
      );
    }
  }

  showSpinCoinValue(show, slotCell) {
    this.addOrRemoveValueContainer(show, slotCell);
    this.valueOverlays[slotCell].coinSpin.visible = show;
  }

  showSpinPotValue(show, slotCell, potType) {
    this.addOrRemoveValueContainer(show, slotCell);
    this.valueOverlays[slotCell].coinSpin.visible = false;
    let potName = potType.toLowerCase();
    this.valueOverlays[slotCell][`${potName}Spin`].visible = show;
  }

  clearAllSpinCoinValues() {
    for (let i = 0; i < this.valueOverlays.length; i++) {
      this.valueOverlays[i].coinSpin.visible = false;
      this.hideAllSpinPots(i);
    }
  }

  hideAllSpinPots(slotCell) {
    this.addOrRemoveValueContainer(false, slotCell);
    if (this.valueOverlays[slotCell][`miniSpin`]) {
      this.valueOverlays[slotCell][`miniSpin`].visible = false;
      this.valueOverlays[slotCell][`megaSpin`].visible = false;
      this.valueOverlays[slotCell][`minorSpin`].visible = false;
      this.valueOverlays[slotCell][`majorSpin`].visible = false;
    }
  }

  //CASHLINK
  setCoinCLSpinValue(slotCell, coinValue) {
    const value =
      PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
        coinValue / 100
      );
    this.valueOverlays[slotCell].cashCoinLinkSpin.setText(value);
  }

  showSpinCLCoinValue(show, slotCell) {
    this.addOrRemoveCLValueContainer(show, slotCell);
    this.valueOverlays[slotCell].cashCoinLinkSpin.visible = show;
  }

  //MOONS
  clearAllSpinMoonValues() {
    for (let i = 0; i < this.valueOverlays.length; i++) {
      for (let j = 1; j < 5; j++) {
        this.valueOverlays[i][`spinMoonValue${j}`].visible = false;
      }
    }
  }

  showSpinMoonValue(show, slotCell, numberOfSpins) {
    this.addOrRemoveMoonContainer(show, slotCell);
    if (show) {
      this.valueOverlays[slotCell][`spinMoonValue${numberOfSpins}`].visible =
        show;
    } else {
      for (let j = 1; j < 5; j++) {
        this.valueOverlays[slotCell][`spinMoonValue${j}`].visible = show;
      }
    }
  }

  onGameConfigEvent() {
    this.initialise();
  }
}

var valuesSpinDisplayCreator = function (json) {
  return new ValuesSpin();
};

var valuesSpinDisplayInitialiser = function (json, buggy) {};

var valuesSpinDisplayFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "ValuesSpin",
  valuesSpinDisplayCreator,
  valuesSpinDisplayInitialiser,
  valuesSpinDisplayFilesRequired
);
